import { BaseModel } from 'src/app/shared/models/base.model';

export class Order extends BaseModel{

    public items:any;
    public member:any;
    public club:any;
    public transaction:any;
    public amount:any;
    public created_at:any;


    static fromJsonToObject(jsonData:any):Order{
        return Object.assign(new Order(),jsonData);
    }
}
